/**
 * @author: yuanchang@baidu.com
 * @datetime: 2017-05-17 16:47:12
 * @file: http api&&config
 */

import axios from "axios";
import Qs from "qs";
import Message from "view-design/src/components/message";
import LoadingBar from "view-design/src/components/loading-bar";

LoadingBar.config({
  color: "#00cc66",
  height: 5
});

let requestCount = 0;

// 创建axios实例
const service = axios.create({
  method: "post",
  responseType: "json",
  // timeout: 10000,
  paramsSerialize(params) {
    return Qs.stringify(params, { arrayFormat: "brackets" });
  },
  transformRequest(data) {
    return Qs.stringify(data, { arrayFormat: "brackets" });
  }
});

function hget(url, param) {
  return axios.get(url, {
    params: param
  });
}

function hpost(url, param) {
  return axios.post(url, param);
}

// request拦截器
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    ++requestCount;
    LoadingBar.start();
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    --requestCount;
    if (response.data) {
      if (response.data.errno === 20) {

        //  window.location = `${
        //    response.data.data.uuap_login_url
        // }/login?service=${location.origin +
        //   location.pathname}&appKey=uuapclient12-13-MISIzENMwXrjbXfzmSo5`;

        window.location = '/login';
      } else {
        const isSuccess = response.data.errno === 0;
        if (isSuccess) {
          if (requestCount === 0) {
            LoadingBar.finish();
          }
        } else {
          if (requestCount === 0) {
            LoadingBar.error();
          }
          Message.error(response.data.errmsg, 10);
        }
        return response.data;
      }
    } else {
      if (requestCount === 0) {
        LoadingBar.error();
      }
      Message.error("system error", 5);
      return Promise.reject(response);
    }
  },
  error => {
    --requestCount;
    if (requestCount === 0) {
      LoadingBar.error();
    }
    Message.error(error.message, 5);
    return Promise.reject(error);
  }
);

export default {
  service,
  request(param) {
    return service(param);
  },
  parse(param) {
    return Qs.parse(param);
  },
  hget,
  hpost
};



// WEBPACK FOOTER //
// ./src/http/index.js